import { render, staticRenderFns } from "./WriteOffDebtLimitter.vue?vue&type=template&id=2b6522f8&scoped=true&"
import script from "./WriteOffDebtLimitter.vue?vue&type=script&lang=js&"
export * from "./WriteOffDebtLimitter.vue?vue&type=script&lang=js&"
import style0 from "./WriteOffDebtLimitter.vue?vue&type=style&index=0&id=2b6522f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6522f8",
  null
  
)

export default component.exports